import { getAuthHeader } from '../tokenStorage';
import { axiosInstance } from './axiosInstance';

export const getDecisionMakerById = async (id) => {
  return axiosInstance.get(`/blapi/decisionMakers/getById/${id}`, {
    headers: getAuthHeader(),
  });
};
